import Vue from 'vue';

Vue.filter('lowerCase', function (text) {
    if(!text) return '';
    return text.toLowerCase();
});